import type { ReactNode } from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { AV_BORDER_LIGHT, AV_TEXT_DARK } from "./askVivo.constants";

type SidePanelShellProps = {
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  actions?: ReactNode;
  closeLabel?: string;
};

export default function SidePanelShell({
  title,
  onClose,
  children,
  actions,
  closeLabel = "Close panel",
}: SidePanelShellProps) {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div
        className="flex h-16 items-center justify-between border-b shrink-0"
        style={{ borderColor: AV_BORDER_LIGHT }}
      >
        <div className="flex h-full min-w-0 flex-1 items-center gap-2 px-4">
          <p className="truncate text-[14px] font-semibold text-[#556C75]">
            {title}
          </p>
          {actions}
        </div>
        <div className="flex h-full shrink-0 items-center gap-2 pr-3">
          <Button
            type="text"
            size="small"
            aria-label={closeLabel}
            icon={<CloseOutlined style={{ color: AV_TEXT_DARK }} />}
            onClick={onClose}
          />
        </div>
      </div>
      <div className="flex flex-1 min-h-0 flex-col overflow-hidden px-4 py-3">
        {children}
      </div>
    </div>
  );
}
